/**
 * Created by WebStorm.
 * User: nirongxu
 * Date: 2018/12/8
 * Description: 文件描述
 */
import esLocale from 'element-ui/lib/locale/lang/es'
const es = {
	routeName: {
		home: 'Página principal',
		applicationList: 'Lista de aplicaciones',
		user: 'Gestión de usuarios',
		publishArticle: 'Página 1',
		permissions: 'Gestión de permisos',
		pageControl: 'Permisos de página',
		PersonalCenter: 'Centro personal',
		personalCenter: 'Centro personal',
		parkingManagement: '停车场管理',
		parkingSetup: '停车场设置',
		parking: '车辆进出记录',
		visitorManagement: '访客机管理',
		visitorSetup: '访客机设置',
		visitorRegisterRecord: '访客登记记录',
		visitorAccessRecord: '访客通行记录',
		accessManagement: '门禁管理',
		access: '门禁记录',
		accessSetup: '门禁设置',
		faceManagement: '人脸管理',
		face: '人脸抓拍记录',
		faceSetup: '人脸机设置',
		// 门禁系统
		personnelManagement: 'Gestión del personal',
		personnelList: '人员名单',
		department: '部门管理',
		equipmentManagement: '设备管理',
		faceDevice: '人脸设备',
		statisticalReports: '统计报表',
		accessRecords: '通行记录',
		//人车布控
		controlCenter: '人车布控',
		controlTpye: '布控类型',
		controlVehicle: '车辆布控',
		vehicleWarning: '车辆预警记录',
		vehicleAcceptance: '车辆预警接收人',
		controlPersonnel: '人员布控',
		PersonnelWarning: '人员预警记录',
		PersonnelAcceptance: '人员预警接收人',
		FaceWarning: '人脸预警记录',
		FaceAcceptance: '人脸预警接收人',
		intelligenceWarning: '智能预警记录',
		intelligenceAcceptance: '智能预警接收人',
		/*安保制度*/
		securitymanagement: '安保制度管理',
		security: '安保制度',
		/*信息登记管理*/
		information: '信息登记管理',
		informationregistration: '信息登记',
		//微信设置
		wechat: '微信管理',
		wechatManagement: '微信人员管理',
		wechatMessage: "微信消息记录",
		//内保管理
		fileManagement: '内保通告管理',
		fileMessage: '内保通告',
		//排班管理
		schedulingManagement: "排班管理",
		schedulingPersonnelManagement: "排班人员管理",
		schedulingSettings: "排班设置",
		/*基础设置*/
		setting: "Autorización",
		permissionsetting: "Permiso",
		unitsetting: "单位管理",
		usersetting: "Usuario",
		print: "Imprimir",

		/*票务基础设置*/
		ticketSetting: "Gestión básica",
		tickesSpot: "Zona escénica",
		ticketScenicname: "Punto escénico",
		ticketChecking: "Sitio web",
		ticketGate: "Equipo",
		ticketEquipment: "Estado",
		/*票务业务管理*/

		ticketManagement: "Negocios",
		ticketMaking: "Tipo de billete",
		ticketCard: "Tarjeta",
		ticketStorage: "Valor almacenado",
		ticketAuthentication: "Testigo",
		ticketMerchandise: "Mercancía",
		ticketMerchandisekind: "Producto",
		ticketPreferential: "Descuento",
		ticketCompensationPrice: "Propagacion",
		ticketBilling: "Facturación",
		ticketVenue: "Lugar del proceso",
		ticketVenuesetup: "场馆管理",
		ticketVenueplan: "场次计划",
		ticketTime: "Itinerario de viaje",
		ticketGroup: "Pasar el equipo",
		ticketCalendar: "Vacaciones",
		ticketControl: "Gerencia regional",
		ticketTimeSharing: "Hora cita",
		/*商品管理 */
		goods: "goods",
		commodity: "commodity",
		gatalogue: "gatalogue",
		shops: "shops",
		goodsloading: "goodsloading",
		Inventory: "Inventory",
		Commoditysales: "Commoditysales",
		Salesdetails: "Salesdetails",

		Warehouse: "Warehouse",
		Entry: "Entry",
		Ticket_Inventory: "Ticket_Inventory",
		/*查询报表*/

		ticketReport: "Reporte",
		ticketrOrder: "Informe de pedido",
		ticketTicket: "Detalles del boleto",
		ticketCode: "Ticket de verificación",
		ticketImport: "Entrar y salir",
		ticketConsume: "Deslizar detalles",
		ticketConsumestate: "No usado",
		ticketRefund: "ticketRefund",
		ticketInventory: "门票库存明细",
		ticketMerchandiseReport: "商品库车明细",
		ticketMerchandiseSale: "商品销售明细",
		ticketFlow: "人流量监控",
		ticketStorageReport: "储值卡消费明细",
		Supplementary: "Supplementary",

		ticketInput: "库存管理",
		ticketType: "录入票类",
		ticketCommodity: "录入商品",

		Stockholder: "Stockholder",
		Shareholder: "Shareholder",
		Share: "Share",
		Statement: "Statement",


		ticketsystem: "Gestión del sistema",
		ticketWechat: "WeChat",
		ticketAlipay: "Alipay",
		ticketDatabase: "Base de datos",
		ticketInformation: "Mensaje del sistema",
		EquipmentUpgrade: "Mejora",
		ticketLog: "Iniciar sesión",


		release: "Anexoón",
		programRelease: "Programa",
		graphicRelease: "Gráfico de vídeo",
		contentRelease: "Iiberación",
		dataRelease: "Kanban de datos",
		ticketStatements: 'Estados financieros',
		datalist: 'datalist',
		passenger: 'passenger',
		camera: 'camera',
		statistics: 'statistics',


		/*售票*/
		PrintTickets: "Imprimir boleto",
		ScanningTicketing: "ScanningTicketing",
		MembershipCard: "Venta de tarjetas",
		StoredCard: "Valor almacenado",
		Refund: "Reembolso",
		Collection: "Operación de boletos",
		Record: "Registro de turno",
		Query: "Consulta de entradas",
		Memberrenewal: "Renovación de tarjeta",
		sellPrintTickets: "Imprimir boleto",
		sellScanningTicketing: "sellScanningTicketing",
		sellPrintTicketsgoods: "sellPrintTicketsgoods",
		sellMembershipCard: "Venta de tarjetas",
		sellStoredCard: "Valor almacenado",
		sellgoods: "sellgoods",
		sellRefund: "Reembolso",
		sellCollection: "Operación de boletos",
		sellRecord: "Registro de turno",
		sellQuery: "Consulta de entradas",
		sellMemberrenewal: "Renovación de tarjeta",
		sellDifference: "Propagacion",
		scan: "scan",
	},
	home: {
		footer1: "provide technical support",
		footer2: "Please use IE11 and above, EDGE, Google, Opera browser to log in",

		text1: "Por favor ingrese el nombre de usuario",
		text2: "Por favor, introduzca su contraseña",
		text3: "Iniciar sesión",
		text_: 'Sistema inteligente de emisión de boletos',
		text: 'Administrar',
		/* text_:'欢迎使用智慧科技馆票务系统',
		text:'智慧科技馆票务系统', */
		Refund: "Reembolso total",
		Cashrefunded: "Reembolso",
		Alipayback: "Reembolso Alipay",
		RefundWechat: "Volver WeChat",
		RefundUnionPay: "Retiro de UnionPay",


		todayEnterCount: "Admisión en el día",
		todayOfflineTicketCount: "Boletos en ventanilla hoy",
		todayOnlineTicketCount: "Compre boletos en línea hoy",
		todayWeChatTicketCount: "Compre boletos en WeChat hoy",

		entercount: "número total de admisiones",
		groupTicketCount: "votos totales del grupo",

		cardTicketCount: "Número total de tarjetas de membresía",
		ordinaryTicketCount: "votos ordinarios totales",
		enterCount: "Total de votos usados",
		onlineTicketCount: "Compras de boletos en línea",
		offlineTicketCount: "Total de compras de boletos fuera de línea",

		weChatTicketCount: "Compra de boletos de WeChat",
		zdj: "Compra de billetes de terminal",
		dsf: "Número de entradas de terceros",
		type: 'Tipo',
		Ordinarycard: "billete normal",
		Membershipcard: "boleto de membresía",
		Storedcard: "boleto de valor almacenado",
		VIP: 'VIP',
		family: "familia",
		Ticketstatistics: "clase de boleto",
		Volume: "Ventas",
		Groupcard: "tarjeta de grupo",
		Transactionanalysis: "Comercio",
		Cash: "dinero en efectivo",
		WeChat: "WeChat",
		Alipay: "Alipay",
		UnionPay: "UnionPay",
		Amount: "Cajero total",
		Monday: "el lunes",
		Tuesday: "martes",
		Wednesday: "miércoles",
		Thursday: "jueves",
		Friday: "Viernes",
		Saturday: "sábado",
		Sunday: "Domingo",
		Total: "total",
		Sourceanalysis: "análisis de fuentes",
		OTA: "OTA",
		OfflineWindow: "ventana sin conexión",
		account: "sin publico",
		Terminal: "Terminal",
		visitorsflowrate: "Análisis de flujo de pasajeros",
		Touristtype: "tipo de visitante"

	},

	ticketspot: {
		id: "Número de serie escénico",
		name: "Nombre del lugar panorámico",
		add: "Agregar lugares pintorescos",
		placeholdername: "Por favor ingrese el nombre del lugar escénico",
		placeholderremark: "Por favor ingrese el lugar pintoresco",
		editspot: "Editar lugares escénicos",
		errorspot: "La longitud del nombre del lugar escénico no puede exceder los 16 caracteres.",
		errorremark: "Los comentarios no pueden tener más de 16 caracteres",


	},
	ticketScenic: {
		ScenicArea_: "Por favor seleccione un lugar escénico",
		Scenicname_: "Por favor seleccione una atracción",
		id: "Número de serie de la atracción",
		name: "Nombre de la atracción",
		ScenicArea: 'Punto panorámico afiliado',
		LimitEnable: "Ya sea para limitar el número de personas",
		LimitCount: "Por favor, introduzca el límite",
		LimitCount_: "El número de personas no puede tener más de 5 caracteres",
		add: "Agregar atracciones",
		placeholdername: "Ingrese el nombre de la atracción",
		placeholderremark: "Por favor ingrese los comentarios de la atracción",
		editspot: "Editar atracciones",
		errorspot: "La longitud del nombre de la atracción no puede exceder los 16 caracteres.",
		errorremark: "Los comentarios no pueden tener más de 16 caracteres",

	},
	ticketgate: {
		constStatus: "Modo puerta abierta",
		ck: "Modo normalmente abierto",
		cb: "Modo normalmente cerrado",
		pt: "Modo normal",
		qx: "Emitir permiso",
		id: "Número de serie del dispositivo",
		name: "El equipo",
		ScenicArea: 'Atesorados',
		zone: "Atracciones",
		deviceNo: "número de equipo",
		moduleType: "Tipo de equipo",
		deviceIP: "IP del dispositivo",
		online: "estado del dispositivo",
		webPort: "Puerto",
		createTime: "Fecha Agregada",

		zx: "en línea",
		lx: "desconectado",
		kz: "Apertura remota",
		qc: "borrar datos",
		addgate: "Agregar equipo",
		deviceNo_: "Por favor, introduzca el código del dispositivo",
		name_: "Por favor ingrese un nombre de dispositivo",
		print: "plantilla de impresión",
		numberzs: "Número de hojas de la máquina de billetes",
		numberzs_: "Por favor ingrese el número de hojas a imprimir",
		ucOpenDoorType: "tipo de puerta",
		ucCommuTyp: "485 método de comunicación",

		uc485Id: "485 ID de comunicación",
		deviceIP_: "Por favor ingrese la IP del dispositivo",
		webPort_: "Ingrese el número de puerto del dispositivo",
		editgate: "editar dispositivo",
		deviceNo_a: "El código del dispositivo no puede estar vacío",
		name_a: "El nombre del dispositivo no puede estar vacío",
		device_a: "Seleccione el tipo de dispositivo",
		ScenicArea_: "Por favor seleccione un lugar escénico",
		zone_: "Por favor seleccione una atracción",
		moduleType_: " Seleccione el tipo de dispositivo",
		Ip: "La IP del dispositivo no puede estar vacía",
		Ip_: " El formato de IP del dispositivo es incorrecto",
		Enter: "Ingresar",
		Out: "afuera",
		door_: "Puerta de acceso inteligente",
		Gate: "Puerta de acceso inteligente",
		Terminal: "Terminal de venta de billetes de autoservicio",
		Handheld: "Terminal de boletos de mano",
		relay: "Relé para abrir la puerta",
		gateplate: "Placa de puerta para abrir la puerta",
		control: "control de acceso",
		Enable: "permitir",
		Disable: "desactivado",
		Import: "importar",
		Export: "salida",
		scope: "Esta operación controlará el dispositivo para abrir la puerta una vez, ya sea para continuar?",
		qxscope: "Esta operación enviará los parámetros del tipo de ticket, los datos del ticket, los permisos correspondientes al ticket y otros parámetros al dispositivo, para continuar.?",
		qxscope_: "Entregado con éxito",
		qxscope_a: "No se pudo entregar",
		door: "Abre la puerta con éxito",
		failure: "No se pudo abrir la puerta",
		Cancel: "Cancelar la operación",
		scope_: "Esta operación borrará la base de datos en el controlador de tickets. Una vez completada la limpieza, debe volver a editar los permisos de los tickets en la gestión de seguimiento del dispositivo. ¿Desea continuar?",
		Cleared: "Borrado con éxito",
		Cleared_: "Borrar fallido",
		IDuc485Id_: "El tamaño no puede ser superior a 255",
		deviceNo_: "El nombre del dispositivo no puede tener más de 16 caracteres.",
		ucOpenDoorType_: "Seleccione el tipo de apertura de la puerta",
		IDuc485Id_a: "485 El método de comunicación no puede estar vacío",
		IDuc485Id_b: "485ID no puede estar vacío",
		print_: "Seleccione una plantilla de impresión",
		printTicketCount: "El número de hojas a imprimir no puede estar vacío",
		deviceIPlength: "La longitud de la IP no puede ser mayor a 15 caracteres",
		namelength: "El nombre del dispositivo no puede tener más de 16 caracteres.",
	},

	ticketmaking: {
		id: "ID de clase de billete",
		name: "Nombre de clase de billete",
		ticketPrice: "precio del boleto",
		// ticketMedium:"Boleto mediano",
		ticketCate: "Categoría de entrada",

		scenicAreaID: "Atesorados",
		scenicAreaID_: "Identificación escénica",
		ticketZone_query: "autorización",

		add: "Añadir tipo de entrada",
		ticketTypeName: "Nombre del ticket",
		ticketTypeName_: "Por favor ingrese el nombre del boleto",
		ticketDisplayPrice: "Precio al exterior",
		ticketDisplayPrice_: "Por favor, introduzca el precio de venta en el extranjero",
		ticketPrice: "Precio de venta",
		ticketPrice_: "Por favor ingrese el precio del boleto",
		ticketMedium: "Boleto medio",
		ticketFeeMethod: "Facturación",
		ticketCate: "Categorías",
		ticketTypeStartingType: "Método de inicio",
		ticketTypeStartingDate: "fecha de inicio",
		date: "seleccione fecha",
		ticketUseDays: "Activo (días)",
		refundRuleID: "Politica de reembolso",
		limitCount: "Limitación wechat",
		limitCount_: "Cuando es 0, el valor predeterminado es ilimitado",
		patchCard: "Llenar la tarjeta",
		checkVal: "Carga la plataforma",
		checkbox1: "sin publico",
		checkbox2: "Terminal",
		checkbox3: "tercero",
		checkbox5: "Mano",
		checkbox4: "subprogramas",
		headPhoto: "foto del billete",
		headPhoto1: "cargar imagen",
		headPhoto2: "Solo se pueden cargar archivos jpg/png y no más de 1 MB (limitado a una sola imagen)",
		edit: "Editar tipo de boleto",
		makForm: "Lista de parámetros de permisos de tickets",
		addmakForm: "Agregar parámetro de permiso de ticket",

		FeeMethod: "camino de paso",
		id_: "ID de serie",
		scenicAreaID_: "Atracciones enlazadas",
		passDeviceList: "Vincular el dispositivo",
		useTimesByDay: "Horarios válidos",
		useTimes: "total",
		ticketValidDays: "fecha válida",
		ticketValidTime: "Tiempo efectivo",
		addsetForm: "Agregar parámetro de permiso de ticket",
		zone: "Atracciones",
		second: "número de días",
		second_: "Por favor, introduzca el número de días",
		totalSecond: "Por favor ingrese el número total de veces",
		throughGroupID: "Permiso de acceso",
		Billing: "Normas de facturación vinculantes",
		isloadedTicket: "Ya sea para cargar el boleto",
		totalTime: "Tiempo total (minutos)",
		totalTime_: "Por favor ingrese el tiempo total",
		totalday: "días totales",
		totalday_: "Por favor ingrese el número total de días",
		pair: "Ya sea para emparejar dentro o fuera",
		name_: "nombre del dispositivo",
		direction: "Dirección de entrada y salida",
		editsetForm: "Editar parámetros de permisos de tickets",
		Medium: "Por favor seleccione un medio",
		Billing: "Seleccione un método de facturación",
		Category: "Porfavor seleccione una categoría",
		Effective: "Por favor, introduzca una fecha de caducidad",
		Company: "Por favor seleccione un lugar escénico",
		TicketTypeStartingType: "Seleccione un tipo de inicio",
		TicketDisplayPrice: "Por favor ingrese precio externo",
		jt: "hoy dia",
		zt: "el dia de ayer",
		yz: "Hace una semana",
		qr: "Tarjeta de código QR",
		ic: "Tarjeta",
		sfz: "tarjeta de identificación",
		rl: "cara humana",
		jc: "contar",
		js: "sincronización",
		ptk: "tarjeta normal",
		ttk: "tarjeta de grupo",
		fkm: "código de pago",
		tqk: "Tarjeta de privilegio",
		sfzyhk: "tarjeta de identificación gratis",
		areaName: "Palabras clave de región libre, varias regiones están separadas por comas",
		areaName_: "Ingrese palabras clave regionales, varias regiones están separadas por comas, como Beijing, Shenzhen",
		minAge: "Límite de edad gratuito",
		passMode: "reglas libres",
		passMode1: "Por edad",
		passMode2: "Por región",
		passMode3: "edad o región",
		passMode4: "edad y región",

		ticketAudioEnable: "Activar la voz",
		ticketAudioEnable0: "no encender",
		ticketAudioEnable1: "encender",

		Type1: "Por fecha de tarjeta",
		Type2: "Por mes natural (1 del próximo mes)",
		Type3: "personalizar",
		Type4: "por fecha límite",
		loaded: "carga",
		loaded_: "no cargar",

		nk: "tarjeta de membresía anual",
		bnk: "Carnet de socio medio año",
		jdk: "Tarjeta trimestral de membresía",
		yk: "tarjeta de membresía mensual",
		zdrk: "tarjeta de dia personalizada",
		zdyk: "tarjeta mensual personalizada",
		zdnk: "tarjeta anual personalizada",
		zzk: "tarjeta de valor almacenado",
		rc: "Sin calendario vinculante",
		namelength: "El nombre del ticket no puede tener más de 16 caracteres",
		ticketUseDayslength: "La longitud válida no puede ser mayor a 5 caracteres",
		limitCountlength: "La longitud límite de WeChat no puede ser mayor a 5 caracteres",
		patchCardlength: "La longitud de la tarjeta complementaria no puede ser superior a 5 caracteres",
		ticketPricelength: "El precio del boleto no puede tener más de 5 caracteres",
		useTimeslength: "El número total de veces no puede tener más de 6 caracteres de longitud.",
		useTimesByDaylength: "El número de días no puede tener más de 6 caracteres de longitud",
		useTimesByDay_: "El número de veces por día no puede ser mayor que el número total de veces",
		ticketTime: "Por favor ingrese el tiempo",
		ticketValidTime_: "El tiempo no puede tener más de 4 caracteres de longitud",
		arrList: "Seleccione el dispositivo correspondiente",
		ticketValidDays_: "El número de días no puede tener más de 4 caracteres de longitud",
		calcRuleName: "sin reglas vinculantes",
		rca: "Ingresar",
		cca: "afuera",
	},

	ticketstorage: {
		card: "Número de billete/número de tarjeta",
		card_: "Introduce el número de billete/tarjeta",
		name: "Nombre",
		name_: "Ingrese su nombre",
		Mobile: "número de teléfono",
		Mobile_: "ingrese el número de teléfono móvil",
		type: "tipo de billete",
		query: "buscar informacion",
		ticketID: "numero de ticket",
		ticketPrice: "precio unitario",
		ticketTypeName: "Nombre de clase de billete",
		ticketBalance: "equilibrio",
		ticketCate: "Categoría de entrada",
		ticketFeeMethod: "Boleto medio",
		ticketStatus: "estado del boleto",
		ticketUserName: "Nombre",
		ticketUserMobile: "Teléfono",
		ticketStart: "fecha del juego",
		subTicketID: "número de billete secundario",
		ticketEnd: "Hora de finalización",
		account: "conductor",
		scope: "funcionar",
		cardmodal: "Editar información personal del miembro",
		ticketTypeName_name: "Nombre del tarjetahabiente",
		ticketUserIDNum: "número de identificación",
		ticketTypeName_card: "número de tarjeta del titular de la tarjeta",
		ticketUserMobile: "teléfono del titular de la tarjeta",
		ticketStart: "Comienza la validez",
		ticketEnd: "Finaliza la validez",
		headPhoto: "foto",
		headPhoto_: "cargar imagen",
		qbzt: "todo estado",
		wyp: "Boleto no verificado",
		yyp: "Comprobado",
		ytp: "Reintegrado",
		yzf: "Abolido",
		yjy: "desactivado",
		ygs: "reportado perdido",
		ygq: "Caducado",
		ticketTypeName_qb: "Todas las entradas",
		mzzd: "El nombre no puede tener más de 12 caracteres",
		sfzzd: "La longitud del nombre de la tarjeta de identificación no puede ser mayor a 18 caracteres",
		sjzzd: "El nombre del número de teléfono no puede tener más de 11 caracteres.",
		sjzzd: "La longitud de la tarjeta no puede ser mayor a 24 caracteres",
		mzzd_: "El nombre no puede tener más de 10 caracteres",
	},

	ticketcard: {
		card: "Número de billete/número de tarjeta",
		card_: "Introduce el número de billete/tarjeta",
		name: "Nombre",
		name_: "Ingrese su nombre",
		Mobile: "número de teléfono",
		Mobile_: "ingrese el número de teléfono móvil",
		type: "tipo de billete",
		query: "Indagar",
		ticketID: "número de tarjeta",
		ticketTypeName: "Nombre de clase de tarjeta",
		ticketCate: "Categoría de entrada",
		ticketPrice: "precio unitario",
		ticketFeeMethod: "Boleto mediano",
		ticketStatus: "estado del boleto",
		ticketUserName: "Nombre",
		ticketUserMobile: "Teléfono",
		ticketStart: "fecha de inicio",
		ticketEnd: "Hora de finalización",
		account: "conductor",
		ticketBalance: "equilibrio",
		ticketTypeName_: "nombre del billete",
		updataForm: "Editar información personal del miembro",
		subTicketID: "Parámetro",
		ticketUserIDNum: "identificación",
		headPhoto_: "foto",
		primary: "funcionar",
		headPhoto_primary: "cargar imagen",
		headPhoto: "Solo se pueden cargar archivos jpg/png y no más de 1 MB (limitado a una sola imagen)",

		updata: "someter",
		closeForm: "Cancelar",
		qbzt: "todo el estado",
		wyp: "Boleto no verificado",
		yyp: "Comprobado",
		ytp: "Reintegrado",
		yzf: "Abolido",
		yjy: "desactivado",
		ygs: "reportado perdido",
		ygq: "Caducado",
		qb: "Todas las entradas",
		error1: "El nombre no puede tener más de 12 caracteres",
		error2: "La longitud del nombre de la tarjeta de identificación no puede ser mayor a 18 caracteres",
		error3: "El nombre del número de teléfono no puede tener más de 11 caracteres.",
		success: "Editar información con éxito",
		error4: "No se pudo editar la información",

		error5: "La longitud de la tarjeta no puede ser mayor a 24 caracteres",
		error6: "La longitud del teléfono no puede ser mayor a 11 caracteres",
		error7: "El nombre no puede tener más de 10 caracteres",

		ptk: "tarjeta normal",
		zzk: "tarjeta de valor almacenado",
		ttk: "tarjeta de grupo",
		nk: "tarjeta de membresía anual",
		bnk: "Carnet de socio medio año",
		jdk: "Tarjeta trimestral de membresía",
		yk: "tarjeta de membresía mensual",

		fkm: "código de pago",
		tqk: "Tarjeta de privilegio",
		zdrk: "tarjeta de dia personalizada",
		zdyk: "tarjeta mensual personalizada",
		zdnk: "tarjeta anual personalizada",
		rl: "cara humana",
		jc: "contar",
		js: "hora",
		rk: "En stock",
		ck: "Agotado",

		headPhoto1: "La imagen de avatar cargada solo puede estar en formato JPG o PNG",

		headPhoto2: "El tamaño de la imagen de avatar cargada no puede exceder 1 MB",

	},
	ticketAuth: {
		id: "número de serie",
		scenicAreaID: "Lugar escénico afiliado",
		isEnable: "Ya sea para habilitar",
		ticketTypeName: "tipo de billete vinculante",
		scope: "funcionar",
		company: "Lugar escénico afiliado",
		addForm: "Añadir una nueva categoría de verificación de entradas",
		ticket: "tipo de billete",
		out: "Ya sea para habilitar",
		resetForm: "Reiniciar",
		primary: "someter",

		closeForm: "Cancelar",
		Error1: "Selecciona un lugar pintoresco",
		Error2: "Por favor seleccione un tipo de boleto",
		yes: "Sí",
		no: "no",
		isEnable1: "desactivado",
		isEnable2: "permitir",
		success: "Agregar información con éxito",
		error: "Error al agregar información",
		success1: "Editar información con éxito",
		error1: "No se pudo editar la información",
		delete: "Esta operación eliminará permanentemente los datos, ¿quieres continuar?",
		delete1: "Información eliminada con éxito",
		delete2: "No se pudo eliminar la información",
	},
	ticketpre: {
		id: "ID de oferta",
		discountName: "Nombre de la oferta",
		scenicAreaID: "Lugar escénico afiliado",
		discountCategory: "Categoría de oferta",
		discountType: "Tipo de oferta",
		scope: "funcionar",
		addForm: "Agregar reglas de descuento",
		discountName: "Nombre de la oferta",
		discountName_: "Ingrese el nombre de la oferta",
		company: "Lugar escénico afiliado",
		discountCategory: "Seleccionar categoría de oferta",

		radio0: "descuento de cantidad total",
		M: "Lleno",
		je: "reducir",
		y: "Yuan",
		radio1: "descuento completo",
		da: "golpear",
		ze: "pliegue",
		radio2: "Descuento total por cantidad",
		radio3: "descuento total",
		text: "Instrucciones de entrada de descuento, como 8.8% de descuento, debe ingresar 88, de lo contrario no será válido y obtendrá un 10% de descuento. Solo ingresa 90",
		radio4: "Cantidad de recarga completa",
		co: "Cargo",
		so: "entregar",
		resetForm: "Cancelar",
		primary: "someter",
		updataForm: "Editar reglas de oferta",
		Error1: "Selecciona un lugar pintoresco",
		Error2: "Seleccione una categoría de oferta",
		Error3: "Por favor ingrese un nombre",
		label1: " descuento de entradas",
		label2: " Oferta de recarga",

		error1: "La longitud del nombre no puede tener más de 24 caracteres",
		error2: "Seleccione una política de descuento",
		error3: "Los datos de la regla no pueden estar vacíos.",
		success: "Agregar información con éxito",
		error: "Error al agregar información",
		success1: "Editar información con éxito",
		delete: "Esta operación eliminará permanentemente los datos, ¿quieres continuar?",
		warning: "insinuación",
		delete1: "Información eliminada con éxito",
		delete2: "No se pudo eliminar la información",
	},

	ticketprice: {
		id: "número de serie",
		scenicAreaID: "Lugar escénico afiliado",
		name: "Nombre de la regla de propagación",
		ticketType: "tipo de billete vinculante",
		scope: "funcionar",
		addForm: "Agregar regla de distribución",
		company: "Lugar escénico afiliado",
		type: "tipo de billete",
		gracePeriod: "Finalización del período de gracia",
		label1: "El primer escenario",
		label2: "Segunda etapa",
		label3: "la tercera fase",
		label4: "cuarta etapa",
		YItime: "Tiempo excedido (minutos)",
		YIprice: "Importe a complementar (yuan)",
		reset: "Reiniciar",
		primary: "someter",
		close: "Cancelar",
		updataForm: "editar nombre",
		Error1: "Por favor ingrese un nombre",
		Error2: "Selecciona un lugar pintoresco",
		Error3: "Por favor seleccione un tipo de boleto",
		error1: "El nombre no puede tener más de 12 caracteres",
		error2: "El período de tiempo de espera de la primera etapa, la cantidad a complementar no puede estar vacía",
		error3: "El tiempo de espera de la primera etapa, el monto a complementar se ingresa incorrectamente y no puede ser inferior a 0",
		error4: "Tiempo de espera, la cantidad a complementar es incorrecta y no puede ser inferior a 0",
		error5: "El ingreso del monto a complementar en la segunda etapa no puede estar vacío",
		error6: "La entrada de tiempo de espera de segundo orden no puede estar vacía",
		error7: "El ingreso del monto a complementar en la tercera etapa no puede estar vacío",
		error8: "La entrada de tiempo de espera de tercer orden no puede estar vacía",
		error9: "El ingreso del monto a complementar en la cuarta etapa no puede estar vacío",
		error10: "La entrada de tiempo de espera de cuarto orden no puede estar vacía",
		error11: "El período de tiempo de espera no puede tener más de 5 caracteres.",
		error12: "El importe a complementar no puede superar los 8 caracteres",
		successadd: "Agregar información con éxito",
		erroradd: "Error al agregar información",
		successedit: "Editar información con éxito",
		erroredit: "No se pudo editar la información",
		delete: "Esta operación eliminará permanentemente los datos, ¿quieres continuar?",
		warning: "insinuación",
		deletesuccess: "Información eliminada con éxito",
		deleteerror: "No se pudo eliminar la información",
	},
	ticketBilling: {

		id: "número de serie",
		calcRuleName: "nombre de facturación",
		scenicArea: "Lugar escénico afiliado",
		calcRuleType: "Tipo de facturación",
		remark: "Instrucciones de facturación",
		scope: "funcionar",
		addForm: "Configuración de regla de facturación agregada",
		calcRuleName: "Nombre de la regla de facturació",

		billingtype: "Tipo de facturación",
		company: "Lugar escénico afiliado",
		out: "¿Está permitido salir?",
		allowOutTimeSpan: "Tiempo permitido para salir (minutos)",
		isAllowUnitSpanDeduction: "Si toda la deducción",
		deductionUnitSpan: "Tiempo de deducción total permitido (minutos)",
		startPrice: "Precio inicial (yuan)",
		maxDayAmount: "total limitado (yuan)",
		maxTotalAmount: "Importe total limitado (yuan)",
		startFreeTime: "Tiempo libre (minutos)",
		graceSpan: "Tiempo de gracia (minutos)",
		deductionGranularity: "Granularidad de deducción (yuan)",
		dayType: "Tipo de corte diario",

		label1: "período de tiempo uno",
		start: "comienzo",
		end: "Terminar",
		YItime: "Comience a facturar cada pocos minutos",
		YItime_: "Por favor ingrese minutos",
		YIprice: "Importe de la deducción (yuan)",
		YIprice_: "Por favor ingrese el monto de la deducción",
		label2: "período de tiempo dos",
		label3: "período de tiempo tres",
		label4: "período de tiempo cuatro",
		label5: "período de tiempo cinco",
		label6: "Fin de semana (sábado, domingo)",
		label7: "vacaciones",

		time1: "fecha de inicio de vacaciones",
		time2: "seleccione fecha",
		time3: "fecha de fin de vacaciones",
		time4: "Período de tiempo de vacaciones",
		reset: "Reiniciar",
		primary: "someter",
		updataForm: "editar reglas",

		Error1: "Ingrese un nombre de regla",
		Error2: "Selecciona un lugar pintoresco",
		Error3: "Seleccione un método de facturación",
		text1: "hoy dia",
		text2: "el dia de ayer",
		text3: "Hace una semana",
		jc: "contar",
		js: "hora",
		yes: "Sí",
		no: "no",
		value1: "No permitido",
		value2: "permitir",
		value3: "día natural",
		value4: "Cálculo de 24 horas",

		error: "El período de tiempo de inicio no puede estar vacío",
		error1: "El primer período de tiempo es incorrecto",
		error2: "Llenado incorrecto en el segundo período",
		error3: "Llenado incorrecto en el tercer período",
		error4: "El cuarto punto está mal llenado",
		error5: "El quinto período está mal llenado",

		error6: "La hora de finalización del primer período no puede ser inferior a la hora de inicio.",
		error7: "La hora de finalización del segundo período no puede ser inferior a la hora de inicio.",
		error8: "La hora de finalización del tercer período no puede ser inferior a la hora de inicio.",
		error9: "La hora de finalización del cuarto período no puede ser inferior a la hora de inicio.",
		error10: "La hora de finalización del quinto período no puede ser inferior a la hora de inicio.",

		error11: "Completado incorrectamente, el final del primer período es mayor que el inicio del segundo período",
		error12: "Completado incorrectamente, el final del segundo período es mayor que el inicio del tercer período",
		error13: "Completado incorrectamente, el final del tercer período es mayor que el inicio del cuarto período",
		error14: "Completado incorrectamente, el final del cuarto período es mayor que el inicio del quinto período",
		error15: "La hora de finalización de vacaciones no puede ser mayor que la hora de inicio",

		zmerror: "El período de inicio del fin de semana no puede estar vacío",
		zmerror1: "Incorrecto llenado en el primer período del fin de semana",
		zmerror2: "Incorrecto llenado en el segundo período del fin de semana",
		zmerror3: "Incorrecto llenado en el tercer período del fin de semana",
		zmerror4: "Llenado incorrecto en el cuarto período del fin de semana",
		zmerror5: "Llenado incorrecto en el quinto período del fin de semana",
		zmerror6: "La hora de finalización del primer período del fin de semana no puede ser inferior a la hora de inicio",
		zmerror7: "La hora de finalización del segundo período del fin de semana no puede ser inferior a la hora de inicio",
		zmerror8: "La hora de finalización del tercer período del fin de semana no puede ser inferior a la hora de inicio.",
		zmerror9: "La hora de finalización del cuarto período del fin de semana no puede ser inferior a la hora de inicio",
		zmerror10: "La hora de finalización del quinto período del fin de semana no puede ser inferior a la hora de inicio",

		Terror1: "Completado incorrectamente, el final del primer período es mayor que el inicio del segundo período",
		Terror2: "Completado incorrectamente, el final del segundo período es mayor que el inicio del tercer período",
		Terror3: "Completado incorrectamente, el final del tercer período es mayor que el inicio del cuarto período",
		Terror4: "Completado incorrectamente, el final del cuarto período es mayor que el inicio del quinto período",
		Terror5: "Completado incorrectamente, el final del primer período del fin de semana es mayor que el inicio del segundo período",
		Terror6: "Completado incorrectamente, el final del segundo período del fin de semana es mayor que el inicio del tercer período",
		Terror7: "Completado incorrectamente, el final del tercer período del fin de semana es mayor que el inicio del cuarto período",
		Terror8: "Completado incorrectamente, el final del cuarto período del fin de semana es mayor que el inicio del quinto período",

		Terror9: "La fecha de inicio de la selección de vacaciones no puede estar vacía",
		Terror10: "La fecha de finalización de la selección de vacaciones no puede estar vacía",
		Terror11: "La hora de inicio de vacaciones no puede estar vacía",
		Terror12: "La hora de finalización de las vacaciones no puede ser inferior a la hora de inicio",
		Terror13: "Período de tiempo incorrecto para vacaciones",
		close: "Cancelar",
		successadd: "Agregar información con éxito",
		erroradd: "Error al agregar información",
		successedit: "Editar información con éxito",
		erroredit: "No se pudo editar la información",
		delete: "Esta operación eliminará permanentemente los datos, ¿quieres continuar?",
		warning: "insinuación",
		deletesuccess: "Información eliminada con éxito",
		deleteerror: "No se pudo eliminar la información",


	},
	tickeTime: {
		id: "Número de serie escénico",
		scenicAreaID: "Lugar escénico afiliado",
		name: "nombre del permiso de acceso",
		scope: "funcionar",
		addForm: "Agregar período de tiempo",

		company: "Lugar escénico afiliado",
		YItime1: "Lunes",
		YItime2: "martes",
		YItime3: "miércoles",
		YItime4: "jueves",
		YItime5: "Viernes",
		YItime6: "sábado",
		YItime7: "Domingo",
		YItime8: "vacaciones",

		start: "comienzo",
		end: "Terminar",
		reset: "Reiniciar",
		primary: "someter",
		updataForm: "editar nombre",
		error1: "Por favor, introduzca un nombre de evento",
		error2: "Selecciona un lugar pintoresco",
		error3: "El nombre no puede tener más de 12 caracteres",

		errorx1: "La hora de inicio del primer segmento no puede estar vacía",
		errorx2: "La hora de finalización del lunes no puede ser inferior a la hora de inicio",
		errorx3: "La hora de finalización del martes no puede ser inferior a la hora de inicio",
		errorx4: "La hora de finalización del miércoles no puede ser inferior a la hora de inicio",
		errorx5: "La hora de finalización del jueves no puede ser inferior a la hora de inicio",
		errorx6: "La hora de finalización del viernes no puede ser inferior a la hora de inicio",
		errorx7: "La hora de finalización del sábado no puede ser inferior a la hora de inicio",
		errorx8: "La hora de finalización del domingo no puede ser inferior a la hora de inicio",
		errorx9: "La hora de finalización de las vacaciones no puede ser inferior a la hora de inicio",

		errorxx1: "Complete incorrectamente, el primer período de tiempo no puede estar vacío, puede completar el segundo período de tiempo",
		errorxx2: "Complete incorrectamente, el segundo período de tiempo no puede estar vacío, puede completar el tercer período de tiempo",

		reset: "Reiniciar",
		primary: "someter",
		close: "Cancelar",
		successadd: "Agregar información con éxito",
		erroradd: "Error al agregar información",
		successedit: "Editar información con éxito",
		erroredit: "No se pudo editar la información",
		delete: "Esta operación eliminará permanentemente los datos, ¿quieres continuar?",
		warning: "insinuación",
		deletesuccess: "Información eliminada con éxito",
		deleteerror: "No se pudo eliminar la información",

	},
	ticketprint: {
		id: "número de serie",
		namedata: "Lugar escénico afiliado",
		templateName: "nombre de la plantilla de impresión",
		templatePath: "ruta de impresión",
		useSourceType: "Escenarios de aplicación",
		isEnablePrint: "Ya sea para habilitar",
		scope: "funcionar",

		addForm: "Agregar plantilla de impresión",
		printType: "Modelo de impresora",
		company: "Lugar escénico afiliado",
		prop: "plantilla de impresión",
		propsm: "Instrucciones de la plantilla de impresión",
		text: "El campo del módulo de impresión establecido debe corresponder uno a uno con el contenido de impresión seleccionado",
		seqID: "número de serie",
		QR: "Código QR",
		ticketID: "numero de ticket",
		ticketTypeName: "tipo de billete",
		ticketStartTime: "Hora de inicio efectiva",
		ticketEndTime: "hora de finalización efectiva",
		ticketDisplayPrice: "tarifa",
		touristName: " Nombre del tarjetahabiente",
		touristMobile: "Número de móvil del titular de la tarjeta",
		touristIDCardNum: "Número de identificación del titular de la tarjeta",
		reset: "Reiniciar",
		primary: "someter",
		close: "Cancelar",


		error1: "Introduzca un nombre de plantilla",
		error2: "Por favor ingrese la ruta",
		error3: "Selecciona un lugar pintoresco",
		yes: "Sí",
		no: "no",
		print1: "DS",
		print2: "DS80",
		print3: "MS80",
		print4: "manejar",
		value1: "boleto de ventanilla",
		value2: "terminal de autoservicio",

		error: "El nombre no puede tener más de 12 caracteres",
		successadd: "Agregar información con éxito",
		erroradd: "Error al agregar información",
		successedit: "Editar información con éxito",
		erroredit: "No se pudo editar la información",
		delete: "Esta operación eliminará permanentemente los datos, ¿quieres continuar?",
		warning: "insinuación",
		deletesuccess: "Información eliminada con éxito",
		deleteerror: "No se pudo eliminar la información",

		qy: "Buscar áreas controladas",
		add: "Añadir zona a autorizar",
		regionName: "La zona a la que pertenece",
		add: "Añadir zona a autorizar",
		regionCode: "código de propiedad",
		scope: "funcionar",
		updata: "control de autorización",
		updatatext: "(Cuando no se selecciona ninguna de las regiones, el sistema está autorizado a cancelar la autorización de control por defecto.)",
		updata: "control de autorización",
		error4: "Por favor seleccione un tipo de boleto",
		error5: "No se pudo agregar, primero seleccione la región",
		error6: "No se pudo agregar, no se puede agregar el área duplicada",
		error7: "Área autorizada exitosa",
		error8: "Área de autorización fallida",
		error9: "El área modificada ha sido autorizada y no se puede eliminar, desmarque la autorización y luego opere",
	},
	ticketsharing: {
		id: "Número de serie escénico",
		name: "nombre",
		startPeriod: "período de tiempo de inicio",
		endPeriod: "período de tiempo final",
		limitCount: "Número de personas que pueden hacer una cita",

		scenicAreaID: "Lugar escénico afiliado",
		scope: "funcionar",
		addForm: "Agregar franja horaria de la cita",
		appointmentConfigName: "Nombre del período de cita",
		company: "Lugar escénico afiliado",
		prop: "período",
		start: "comienzo",
		end: "Terminar",
		reset: "Reiniciar",
		primary: "someter",
		close: "Cancelar",
		updataForm: "editar nombre",
		text: "No hay límite cuando el número de reservas introducidas es 0",

		Error1: "Por favor, introduzca un nombre de evento",
		Error2: "Selecciona un lugar pintoresco",
		Error3: "Por favor, introduzca el número de reservas",
		Error4: "El nombre no puede tener más de 12 caracteres",
		Error5: "El número de personas ingresadas no puede ser menor a 0",
		Error6: "La longitud del número de personas no puede ser mayor a 7 caracteres",
		Error7: "la hora de inicio no puede estar vacía",
		Error8: "La hora de finalización no puede estar vacía",
		Error9: "La hora de finalización no puede ser inferior a la hora de inicio",

		successadd: "Agregar información con éxito",
		erroradd: "Error al agregar información",
		successedit: "Editar información con éxito",
		erroredit: "No se pudo editar la información",
		deletesuccess: "Información eliminada con éxito",
		deleteerror: "No se pudo eliminar la información",
		delete: "Esta operación eliminará permanentemente los datos, ¿quieres continuar?",
		warning: "insinuación",

	},
	ticketsetting: {
		id: "número de serie",
		name: "nombre de permiso",
		namedata: "Lugar escénico afiliado",
		isEnable: "Ya sea para habilitar",
		scope: "funcionar",
		addForm: "Agregar permiso",
		label: "Distinción de roles de permisos",
		radio_0: "administrador",
		radio_1: "conductor",

		/*基础设置*/
		setting: "Autorización",
		permissionsetting: "Permiso",
		unitsetting: "单位管理",
		usersetting: "Usuario",
		print: "Imprimir",

		/*票务基础设置*/
		ticketSetting: "Gestión básica",
		tickesSpot: "Zona escénica",
		ticketScenicname: "Punto escénico",
		ticketChecking: "Sitio web",
		ticketGate: "Equipo",
		ticketEquipment: "Estado",
		/*票务业务管理*/

		ticketManagement: "Negocios",
		ticketMaking: "Tipo de billete",
		ticketCard: "Tarjeta",
		ticketStorage: "Valor almacenado",
		ticketAuthentication: "Testigo",
		ticketMerchandise: "Mercancía",
		ticketMerchandisekind: "Producto",
		ticketPreferential: "Descuento",
		ticketCompensationPrice: "Propagacion",
		ticketBilling: "Facturación",
		ticketVenue: "Lugar del proceso",
		ticketVenuesetup: "场馆管理",
		ticketVenueplan: "场次计划",
		ticketTime: "Itinerario de viaje",
		ticketGroup: "Pasar el equipo",
		ticketCalendar: "Vacaciones",
		ticketControl: "Gerencia regional",
		ticketTimeSharing: "Hora cita",
		/*查询报表*/
		sellPrintTicketsgoods: "sellPrintTicketsgoods",
		ticketReport: "Reporte",
		ticketrOrder: "Informe de pedido",
		ticketTicket: "Detalles del boleto",
		ticketCode: "Ticket de verificación",
		ticketImport: "Entrar y salir",
		ticketConsume: "Deslizar detalles",
		ticketConsumestate: "No usado",

		ticketInventory: "门票库存明细",
		ticketMerchandiseReport: "商品库车明细",
		ticketMerchandiseSale: "商品销售明细",
		ticketFlow: "人流量监控",
		ticketStorageReport: "储值卡消费明细",


		ticketInput: "库存管理",
		ticketType: "录入票类",
		ticketCommodity: "录入商品",

		ticketsystem: "Gestión del sistema",
		ticketWechat: "WeChat",
		ticketAlipay: "Alipay",
		ticketDatabase: "Base de datos",
		ticketInformation: "Mensaje del sistema",
		EquipmentUpgrade: "Mejora",
		ticketLog: "Iniciar sesión",


		release: "Anexoón",
		programRelease: "Programa",
		graphicRelease: "Gráfico de vídeo",
		contentRelease: "Iiberación",
		dataRelease: "Kanban de datos",
		ticketStatements: 'Estados financieros',

		/*售票*/
		PrintTickets: "Imprimir boleto",
		ScanningTicketing: "扫描售票",
		MembershipCard: "Venta de tarjetas",
		StoredCard: "Valor almacenado",
		Refund: "Reembolso",
		Collection: "Operación de boletos",
		Record: "Registro de turno",
		Query: "Consulta de entradas",
		Memberrenewal: "Renovación de tarjeta",
		sellPrintTickets: "Imprimir boleto",
		sellScanningTicketing: "扫描售票",
		sellMembershipCard: "Venta de tarjetas",
		sellStoredCard: "Valor almacenado",
		sellRefund: "Reembolso",
		sellCollection: "Operación de boletos",
		sellRecord: "Registro de turno",
		sellQuery: "Consulta de entradas",
		sellMemberrenewal: "Renovación de tarjeta",
		sellDifference: "Propagacion",

		updataForm: "Editar permiso",
		Error1: "Ingrese un nombre de permiso",
		Error2: "Selecciona un lugar pintoresco",
		label1: "permitir",
		label2: "No disponible",
		sell: "Venta de boletos",
		error1: "El nombre no puede tener más de 12 caracteres",
		error1: "Marque las funciones de permiso que deben abrirse",

		successadd: "Agregar información con éxito",
		erroradd: "Error al agregar información",
		successedit: "Editar información con éxito",
		erroredit: "No se pudo editar la información",
		delete: "Esta operación eliminará permanentemente los datos, ¿quieres continuar?",
		warning: "insinuación",
		deletesuccess: "Información eliminada con éxito",
		deleteerror: "No se pudo eliminar la información",
		reset: "Reiniciar",
		primary: "someter",
		close: "Cancelar",
	},
	ticketuser: {
		id: "ID",
		account: "nombre de usuario",
		name: "nombre de permiso",
		namedata: "Lugar escénico afiliado",
		namedataid: "lugar escénicoID",
		isEnable: "Ya sea para habilitar",
		scope: "funcionar",
		cz: "Reiniciar",
		addForm: "Usuarios nuevos",
		name_: "nombre de usuario",
		password: "contraseña de la cuenta",
		passworddata: "confirmar Contraseña",
		passworddata: "confirmar Contraseña",
		company: "Lugar escénico afiliado",
		zone: "Atracciones",
		user: "Elige permisos",
		updataForm: "editar usuario",
		password: "nueva contraseña",
		passworddata_: "Confirmar la nueva contraseña",
		Error1: "Por favor ingrese un nombre",
		Error2: "Por favor, ingrese contraseña",
		Error3: "Por favor, confirme su contraseña",
		Error4: "Por favor seleccione permiso",
		Error5: "Selecciona un lugar pintoresco",
		label1: "permitir",
		label2: "No disponible",
		error1: "El nombre no puede tener más de 12 caracteres",
		error2: "Los comentarios no pueden tener más de 64 caracteres",
		error3: "La longitud de la contraseña no puede ser mayor a 16 caracteres",
		error4: "Las dos contraseñas ingresadas no coinciden",

		error5: "Restablecimiento de contraseña exitoso",
		error6: "No se pudo restablecer la contraseña",
		error7: "No se puede eliminar la cuenta actualmente en uso",

		successadd: "Agregar información con éxito",
		erroradd: "Error al agregar información",
		successedit: "Editar información con éxito",
		erroredit: "No se pudo editar la información",
		delete: "Esta operación eliminará permanentemente los datos, ¿quieres continuar?",
		warning: "insinuación",
		deletesuccess: "Información eliminada con éxito",
		deleteerror: "No se pudo eliminar la información",
		remarks: "Observación",
		reset: "Reiniciar",
		primary: "someter",
		close: "Cancelar",

	},

	ticketorder: {

		timeList: "fecha de orden",

		zhi: "para",
		start: "fecha de inicio",
		end: "fecha final",
		start: "fecha de inicio",
		scenicArea: "lugar escénico",
		zone: "Atracciones",
		cardlist: "Número de orden",
		name: "Nombre",
		fs: "método de pago",
		zt: "Expresar",
		qd: "canal",
		yh: "usuario",
		query: "Indagar",
		orderID: "Número de orden",
		excel: "exportar",
		ticketNum: "número de hojas",
		orderAmount: "Total de la orden",
		preferentialAmount: "Precio descontado",
		orderTime: "Precio descontado",
		orderPayment: "método de pago",
		orderStatus: "Expresar",
		account: "conductor",
		scope: "funcionar",
		orderData: "Detalles",
		makForm: "Detalles del boleto",
		ticketID: "numero de ticket",
		ticketStatus: "estado del boleto",
		ticketTypeName: "nombre del billete",
		ticketPrice: "precio unitario",
		ticketUserName: "Nombre",
		ticketUserMobile: "número de teléfono",
		ticketUserIDNum: "tarjeta de identificación",
		ticketStart: "Tiempo de juego",
		ticketEnd: "Vencimiento",
		value1: "todos",
		value2: "boleto de ventanilla",
		value3: "OTA",
		value4: "sin publico",
		value5: "Terminal",
		value6: "Mano",

		label1: "todos",
		label2: "boletos pagados",
		label3: "Boleto no pagado",
		label4: "Reembolso no reembolsado",
		label5: "El reembolso ha sido reembolsado",

		fs1: "todos",
		fs2: "dinero en efectivo",
		fs3: "Código de pago de WeChat",
		fs4: "Pago del Mini Programa",
		fs5: "pago de cuenta oficial",
		fs6: "Código de pago Alipay",
		fs7: "Tarjetas UnionPay",
		fs8: "pago en línea",
		fs9: "Yangchengtong",
		fs10: "Escaneo WeChat",
		fs11: "Escaneo Alipay",

		text1: "la semana pasada",
		text2: "el mes pasado",
		text3: "últimos tres meses",

		text: "Detalles del pedido",
		account_: "Todo el personal",

		error1: "La longitud de la tarjeta no puede ser mayor a 24 caracteres",
		error2: "La longitud del teléfono no puede ser mayor a 11 caracteres",
		error3: "El nombre no puede tener más de 10 caracteres",

		zt0: "En stock",
		zt1: "Agotado",

		zt2: "Boleto no verificado",
		zt3: "Comprobado",
		zt4: "Reintegrado",
		zt5: "Abolido",
		zt6: "desactivado",
		zt7: "reportado perdido",
		zt8: "Caducado",

		timeListx: "fecha de compra",
		card: "numero de ticket",

		Mobile: "número de teléfono",
		type: "tipo de billete",
		ticketCate: "Categoría de entrada",
		ticketFeeMethod: "Boleto mediano",

		ticketUserResidence: "dirección",
		ticketUserCompany: "unidad",
		zoneData: "Parámetros del billete",
		makForm_: "Detalles de parámetros de atracciones de boletos",
		remainTimesByDay: "total",
		remainTimes: "tiempos restantes",
		remainValidTime: "Tiempo restante",

		ptk: "tarjeta normal",
		ttk: "tarjeta de grupo",
		fkm: "código de pago",
		tqk: "Tarjeta de privilegio",
		nk: "tarjeta de membresía anual",
		bnk: "Carnet de socio medio año",
		jdk: "Tarjeta trimestral de membresía",
		yk: "tarjeta de membresía mensual",
		zdrk: "tarjeta de dia personalizada",
		zdyk: "tarjeta mensual personalizada",
		zdnk: "tarjeta anual personalizada",
		zzk: "tarjeta de valor almacenado",
		sfz: "tarjeta de identificación gratis",

		Error1: "Selecciona un lugar pintoresco",

		Error2: "Detalles del boleto",
		wu: "ninguna",
		rl: "cara humana",
		jc: "contar",
		js: "hora",

		textx: "Detalles de validación y parámetros del ticket",
		yztime: "tiempo de verificación",

		timelist_x: "Fecha de entrada y salida",

		sb: "equipo",
		fx: "dirección",
		deviceName: "equipo de paso",
		zoneName: "Atracciones",
		recordTime: "Tiempo de admision",
		direction: "Dirección de entrada y salida",
		temperature: "valor de temperatura",
		openNumber: "Número de aperturas de puertas",
		fx1: "todos",
		fx2: "Ingresar",
		fx3: "afuera",
		out: "Detalles de entrada y salida",
		type_: "Todas las entradas",
		sb_: "Todo el equipamiento",

		timelist_c: "fecha de consulta",
		time: "tiempo",
		orderCount: "numero de pedido",
		amount: "Total de la orden",
		actualAmount: "la cantidad real",
		refundAmount: "cantidad devuelta",
		ticketCount: "numero de boletos",
		download: "Detalles del estado financiero",

		options_company: "Todos los lugares pintorescos",
	},
	ticketlog: {
		options_company: "grabar fecha",
		ticketID: "numero de ticket",
		cz: "Tipo de operación",
		company: "Lugar escénico afiliado",
		zone: "Atracciones",
		dev: "Lista de dispositivos",
		zx: "Resultados de la",
		query: "Preguntar",
		id: "número de serie",
		deviceName: "nombre del dispositivo",
		scenicareaName: "Lugar escénico afiliado",
		zoneName: "Atracciones",
		operate: "Tipo de operación",
		operateType: "funcionar",
		exec_result: "Resultados de la",
		param1: "parámetro1",
		param2: "parámetro2",
		recordTime: "tiempo record",
		text1: "la semana pasada",
		text2: "el mes pasado",
		text3: "últimos tres meses",
		label1: "información de la puerta",
		label2: "Información del personal",
		label3: "tipo de billete",
		label4: "información de entradas",
		label5: "pasar grupo",
		label6: "calendario",
		label7: "grupo de puertas",
		label8: "reglas de facturación",
		label9: "Apertura remota",
		label10: "Actualización remota",
		label11: "control regional",
		label12: "limpiar la base de datos",

		label13: "ejecución exitosa",
		label14: "No se pudo ejecutar",
		error: "La longitud del ticket no puede tener más de 18 caracteres",
	},
	center: {
		accountNumber: "cuenta",
		userId: "usuarioID",
		userName: "nombre de usuario",
		companyCode: "codificación",

		updataForm: "cambiar la contraseña",
		oldPassword: "Contraseña anterior",
		newPassword: "nueva contraseña",
		newPassword1: "confirmar Contraseña",


		Error1: "La contraseña anterior no puede estar vacía",
		Error2: "La contraseña anterior debe tener entre 1 y 12 dígitos",
		Error3: "La nueva contraseña no puede estar vacía",
		Error4: "La nueva contraseña debe tener de 1 a 12 dígitos",
		Error5: "confirmar contraseña no puede estar en blanco",
		Error6: "Confirmar la longitud de la contraseña debe ser de 1 a 12 dígitos",
		Error7: "Las contraseñas de confirmación ingresadas no coinciden",
		Error8: "la contraseña ha sido actualizada",
		Error9: "No se pudo cambiar la contraseña, verifique cuidadosamente la contraseña anterior y la nueva contraseña",
		Error10: "No se pudo cambiar la contraseña",

	},
	ticketsell: {
		name: "nombre del billete",
		ticketDisplayPrice: "Mostrar precio",
		price: "precio de venta",
		num: "cantidad",

		numlist: "precio total",
		countList: "cantidad total",
		countnum: "La cantidad total",
		countList_: "Importe a cobrar",
		fs: "método de promoción",
		zf: "pagar",
		zf1: "dinero en efectivo",
		zf2: "código de pago",
		zf3: "WeChat",
		zf4: "Alipay",
		zf5: "UnionPay",
		ss: "realmente recibido",
		zl: "cambio",
		ys: "cuenta por cobrar",
		yh: "descuento",
		touristName: "Nombre",
		touristMobile: "Número",
		touristIDCardNum: "tarjeta de identificación",
		touristCompany: "unidad",
		card_id: "leer tarjeta de identificación",
		radio_1: "una persona un voto",
		radio_2: "un voto",
		add: "Venta de entradas",
		updataForm: "Escanear código",
		updata: "Por supuesto",

		Error: "no puede estar vacío o 0",
		Error1: "turistas",
		Error2: "Identificación no encontrada",
		Error3: "Controlador de tarjeta de identificación no encontrado o error de servicio, comuníquese con el administrador",
		Error4: "Escanea el código de pago",
		Error5: "El pago es exitoso, la compra del boleto es exitosa",
		Error6: "Pago fallido, emisión de boletos fallida",
		Error7: "No se pudo emitir un boleto",
		Error8: "sin descuento",
		Error9: "Por favor seleccione el tipo de boleto para vender",
		Error10: "Un boleto para varias personas solo puede elegir un tipo de boleto para la venta",
		Error11: "Por favor espere para imprimir",
		Error12: "Compra exitosa de boletos",
		Errorx: "Por favor espere el pago",

		card: "Tipo de tarjeta de membresía",
		ticket_card: "número de tarjeta",
		IDcardticketMedium: "número de identificación",
		ICcard_T: "días de membresía",
		ICcard_Y: "Meses de membresía",
		ICcard_N: "Años de membresía",
		name_: "Nombre",
		mobile: "Número",
		countList_d: "precio unitario",
		type: "Membresía Medio",

		upload: "foto de la cara",
		upload_: "cargar imagen",
		elupload: "Solo se pueden cargar archivos jpg/png y no más de 1 MB",

		Errorc1: "Seleccione un tipo de tarjeta de membresía",
		Errorc2: "El número de tarjeta no puede estar vacío",
		Errorc3: "El nombre no puede estar vacío",
		Errorc4: "El número de móvil no puede estar vacío",
		Errorc5: "Por favor ingrese un número de teléfono válido",
		Errorc6: "¡La compra del boleto es exitosa, pero la impresión falla! No se ha creado la plantilla de impresión, compruebe la plantilla de impresión de fondo",
		Errorc7: "El ticket ya existe, ¿quieres revenderlo",
		Errorc8: "insinuación",
		Errorc9: "Por favor seleccione un tipo de boleto",

		Errorc10: "Ingrese un número válido de días, no más de 6000",
		Errorc11: "Ingrese un número válido de días",
		Errorc12: "Por favor ingrese los días de membresía",
		Errorc13: "Ingrese un número válido de meses",
		Errorc14: "Ingrese un número válido de meses, no más de 100",
		Errorc15: "Por favor ingrese el número de meses de membresía",
		Errorc16: "Ingrese un número válido de años",
		Errorc17: "Ingrese un número válido de años, no más de 30 años",
		Errorc18: "Por favor ingrese el número de años de membresía",
		Errorc19: "Cuando el medio de la tarjeta de identificación, ingrese el número de tarjeta de identificación como el número de tarjeta",
		Errorc20: "El número de tarjeta no puede estar vacío",
		Errorc21: "El nombre no puede estar vacío",
		Errorc22: "La longitud de la tarjeta no puede ser mayor a 24 caracteres",
		Errorc23: "La longitud de la tarjeta de identificación no puede exceder los 18 caracteres",
		Errorc24: "La longitud del teléfono no puede ser mayor a 11 caracteres",
		Errorc25: "El nombre no puede tener más de 10 caracteres",
		Errorc26: "El número de tarjeta no puede contener caracteres chinos, confirme su método de entrada o vuelva a ingresar",

		cz: "Cantidad de recarga",
		zs: "regalo de recarga",
		cr: "La cantidad real cargada a la tarjeta",
		czje1: "Por favor ingrese el monto de la recarga",
		czje2: "El monto de la recarga no puede ser 0",

		primary: "Por supuesto",
		close: "Cancelar",

		time: 'tiempo',


		query: 'Comprobar número de tarjeta',
		ticketID: 'número de tarjeta',
		ticketID_: 'Número de tarjeta',
		id: "número de serie",
		ticketPrice: "precio unitario",
		ticketTypeName: "Nombre del ticket",
		ticketCate: "Categoría de entrada",
		ticket_Cate: "ID de clase de billete",
		ticketFeeMethod: "Boleto medio",
		ticketBalance: "saldo de boletos",
		ticketStatus: "estado del boleto",
		ticketStart: "fecha del juego",
		ticketEnd: "Hora de finalización",
		subTicketID: "Details",
		xf: "Renovación",
		gs: "Disable",
		jg: "Enable",
		bk: "tarjeta suplementaria",
		y1: "enero",
		y3: "Marzo",
		y6: "Junio",
		j1: "1 temporada",
		j3: "3 temporadas",
		j6: "6 temporadas",
		n1: "1 año",
		n2: "2 año",
		n3: "3 año",
		n6: "6 año",
		b1: "medio año",

		time1: "Tiempo de renovación (mes)",
		time2: "Tiempo de renovación (trimestre)",
		time3: "Tiempo de renovación (año)",
		time4: "Tiempo de renovación (días)",
		price1: "Cantidad de renovación",

		price2: "Cantidad de recarga",
		zh: "Suma global",
		list_cz: "Renovación",
		card_xu: "Confirmar renovación",
		newcard_ID: "número de tarjeta suplementaria",
		card_bu: "Confirmar la tarjeta de reemplazo",
		qt: "otro",

		makForm: "Detalles de parámetros de atracciones de boletos",
		scope: "Atracciones",
		remainTimesByDay: "total",
		remainTimes: "tiempos restantes",
		remainValidTime: "Tiempo restante",
		message1: "Renovación exitosa",
		message2: "Renovación fallida",
		message3: "Por favor seleccione el tiempo de renovación primero",
		message4: "Esta operación deshabilitará el cambio de tarjeta, ya sea para continuar",
		message5: "Reportar perdido con éxito",
		message6: "No se pudo informar la pérdida",
		message7: "Esta operación desvinculará y cambiará la tarjeta, ya sea para continuar",
		message8: "Desenganchado con éxito",
		message9: "Error al desvincular",
		message10: "Por favor ingrese un contenido de la consulta",
		message11: "El monto de la renovación no puede estar vacío, ingrese el monto",
		message12: "El monto de la renovación es incorrecto, ingrese el monto correcto",
		message13: "Seleccione un tiempo de renovación",

		message14: "El número de días para la renovación no puede exceder los 5000 días.",
		message15: "El número de meses para la renovación no puede ser mayor a 100 meses",
		message16: "El número de años de renovación no puede exceder los 20 años.",
		message17: "El número de tarjeta no puede estar vacío, verifique el número de tarjeta seleccionado",
		message18: "Esta operación completará la operación de recarga de la tarjeta, la nueva tarjeta heredará completamente los datos de información de la tarjeta anterior, ya sea para continuar",
		message19: "Los números de tarjetas adicionales no pueden ser iguales",
		message20: "El número de tarjeta suplementario no puede estar vacío",
		message21: "El reemplazo de la tarjeta es exitoso",
		message22: "Reemplazo de tarjeta fallido",
		message23: "El estado de la tarjeta no se puede reponer",
		message24: "Las tarjetas regulares no se pueden reemplazar",
		message25: "La tarjeta de grupo no se puede reemplazar",
		message26: "La información de la tarjeta se obtuvo con éxito, siga los pasos a continuación",
		message27: "El estado de la tarjeta no se puede renovar",
		message28: "La tarjeta regular no se puede renovar",
		message29: "No se puede renovar la tarjeta de grupo",
		ticketMedium: "Boleto medio",
		ticketBalance: "equilibrio",
		return_card: "Introduzca el número de tarjeta/número de billete/número de pedido",
		ticketID_return: "numero de ticket",
		isRefund: "¿Es reembolsable?",
		refundAmount: "equilibrio",
		orderPayment: "método de pago",
		ticketFeeMethod_: "método de facturación",
		list_yt: "debe ser retirado",
		list_sx: "tasa de tramitación",
		list_st: "Jubilarse",
		orderPaymentID: "ID de reembolso",
		zfisRefund: "reembolso",
		zf6: "Código de pago de WeChat",
		zf7: "Código de pago Alipay",
		zf8: "pago de cuenta oficial",
		zf9: "Pago del Mini Programa",
		refund: "Confirmar reembolso",
		refund_1: "No reembolsable",
		refund_2: "Reintegrable",

		message30: "Por favor, introduzca el número de ticket o número de pedido",
		message31: "No hay boleto reembolsable en el número de boleto o pedido, puede ir al boleto para verificar la información de estado específica",
		message34: "Por favor seleccione el billete a reembolsar",
		message32: "El reembolso es exitoso",
		message33: "Error al reembolsar",

		qp: "recogida de entradas",

		hx_: "Cancelación de boletos",
		qplist: "Procesamiento de boletos/recogida de boletos",
		text: "Al solicitar información turística, el código QR electrónico en manos de los turistas se puede imprimir en un código QR en papel. Independientemente del estado del billete. Seleccione los boletos que necesita imprimir, o seleccione todos para imprimir",
		cardlist: "número de pedido/boleto",
		print: "imprimir boletos",
		orderID: "Pedido",
		account: "conductor",
		ticketUserCompany: "unidad",
		qplist_: "Procesamiento de boletos/verificación de boletos",
		text_: "Al consultar la información turística, el pedido es un número de 18 dígitos que comienza con DD, y el número del boleto es un número de 18 dígitos que comienza con una sola letra.Si el estado del boleto no está marcado, después de hacer clic en el check-off, el billete no puede pasar por las puertas, etc. equipos",
		cardlist_: "Introduce el número de ticket/o número de pedido",
		cardlist_list: "Número de billete/pedido",
		query_list: "buscar informacion",
		query_: "Consultar la información del ticket que necesita ser cancelado",
		orderIDhx: "cancelar todo",
		hx: "pedir por escrito",
		warning1: "Por favor ingrese los datos a consultar",
		warning2: "La longitud de la tarjeta no puede ser mayor a 24 caracteres",
		warning3: "El nombre no puede tener más de 10 caracteres",
		warning4: "La longitud de la tarjeta de identificación no puede exceder los 18 caracteres",
		warning5: "Esta operación cancelará el ticket, ¿quieres continuar",
		warning6: "Cancelación exitosa",
		warning7: "Cancelación fallida",
		warning8: "Esta operación cancelará todos los tickets del pedido. ¿Quieres continuar?",
		warning9: "Esta operación cancelará todos los tickets del pedido. ¿Quieres continuar?",
		warning10: "Por favor seleccione el boleto que desea imprimir",
		warning11: "Esta operación imprimirá el ticket, ¿quieres continuar?",
		warning12: "imprimir con éxito",
		warning13: "impresión fallida",
		warning14: "No se pudo imprimir, comuníquese con el administrador ",
		warning15: "Cancelar impresión",


		ticketCount: "total",
		OrdinaryCard: "billete normal",
		StoreCard: "tarjeta de valor almacenado",
		MembershipCard: "tarjeta de membresia",
		GroupCard: "tarjeta de grupo",
		RticketCount: "Número total de reembolsos",
		amount: "cajero total",
		Cash: "dinero en efectivo",
		Alipay: "Alipay",
		WeChat: "WeChat",
		UnionPay: "UnionPay",
		Ramount: "reembolso total",
		RCash: "Reembolso",
		RAlipay: "Reembolso Alipay",
		RWeChat: "Volver WeChat",
		RUnionPay: "Retiro de UnionPay",
		Samount: "Total pagado",
		xd: "Registro de pedidos",
		xq: "Registro de detalles del billete",
		ticketNum: "número de hojas",
		orderAmount: "Total de la orden",
		preferentialAmount: "Precio descontado",
		orderTime: "tiempo de la orden",
		orderPayment: "método de pago",
		orderStatus: "Expresar",
		id_query: "Modificar pago",
		orderData: "Detalles",
		hidelist: "Registro de detalles del billete",
		ticketSum: "Número de boletos comprados",
		refundTicketSum: "Número de reembolsos",
		actualAmount: "Cantidad de ventas real",
		ticketRechargeAmount: "equilibrio",
		printticket: "Imprimir",
		updataForm_: "Editar método de pago",

		zoneData: "Parámetros de atracciones correspondientes",

	},

	ticket: {
		message1: "La cuenta no puede estar vacía",
		message2: "la contraseña no puede estar en blanco",
		message3: "Inicio de sesión exitoso, cargando.....",
		message4: "Inicio de sesión fallido, servicio no conectado",
		yes: "Sí",
		no: "no",
		reset: "Reiniciar",
		primary: "Por supuesto",
		remark: "Observación",
		scope: "funcionar",
		close: "Cancelar",
		successadd: "Agregar información con éxito",
		erroradd: "Error al agregar información",
		successedit: "Editar información con éxito",
		erroredit: "No se pudo editar la información",
		delete: "Esta operación eliminará permanentemente los datos, quieres continuar?",
		warning: "aviso",
		deletesuccess: "Información eliminada con éxito",
		deleteerror: "No se pudo eliminar la información",
		headPhoto: "La imagen de avatar cargada solo puede estar en formato JPG o PNG",
		headPhoto1: "El tamaño de la imagen de avatar cargada no puede exceder 1 MB",
		//补译
		setqx: "Permisos de emisión personalizados",
		deviceParam: "Parámetros básicos del equipo",
		ticketTypeParam: "Parámetros de permisos de billetes",
		ordinaryTicketParam: "Información sobre billetes ordinarios",
		membershipTicketParam: " Información de la tarjeta de membresía",
		Errorx13: "En proceso...",
		company: "Por favor, elija el lugar escénico",
		addForm_: "Configuración simultánea del dispositivo",
		deviceSoftVersion: "Versión del controlador",
		zdyqx_query: "Emisión de permisos personalizados",
		tt: "Explicación de sincronización: el Fondo sincronizará los datos con el dispositivo en tiempo real por defecto. si el Fondo interactúa con frecuencia (durante la temporada alta del parque), se puede cerrar la sincronización. el sistema cambia al Fondo del software de solicitud activa del dispositivo, lo que reduce en gran medida la presión del servidor en segundo plano",
		company_: "Lugar escénico al que pertenece",
		tt_: "Si sincronizar",
		tt_title: "Configuración simultánea",
		addFormdata_: "Configuración de más entradas",
		isIncomeDistribution: "Si distribuir los ingresos",
		touristType: "Tipos de turistas",
		enterMethod: "Forma de cruzar la puerta",
		isAppointmentEnable: "Si abrir una cita de Wechat",
		saleEndTime: "Wechat límite de tiempo para hacer pedidos",
		isGetTicketPass: "Si recoger billetes para pasar",
		isRefundCheck: "Revisión de reembolso",
		wx: "Instrucciones de reserva de Wechat",
		isRealName: "Si quieres una tarjeta de identificación",
		enterMode: "Tiempo de entrada en el parque",
		reservationInstructions: "Método de uso",
		detailsExplain: "Descripción del proyecto de juego",
		makForm_gj: "Lista de parámetros avanzados de la categoría de billetes",
		add_gj: "Añadir parámetros avanzados de la categoría de billetes",
		id: "Número de serie",
		personTicketBindingMode: "Modelo de tarjeta de identificación",
		enablePasswordMode: "Leer la auditoría de contraseña",
		checkRefundMode: "Si el reembolso es obligatorio",
		addForm_gjlist: "Añadir parámetros avanzados de la categoría de billetes",
		checkPassword: "Contraseña de auditoría",
		updataForm_gjlist: "Editar parámetros avanzados de la categoría de billetes",
		enterMethod1: "Una persona, un voto",
		enterMethod2: "Un voto y más personas",
		touristType1: "Ordinario",
		touristType2: "Niños menores de 1,3 metros y 6 años (incluidos)",
		touristType3: "Menores",
		touristType4: "Estudiantes",
		touristType5: "Ancianos",
		touristType6: "Personas con discapacidad",
		touristType7: "Militares en servicio activo",
		touristType8: "Familiares de militares en servicio activo",
		touristType9: "Jubilados del ejército",
		touristType10: "Militares discapacitados",
		touristType11: "Sobrevivientes de mártires",
		touristType12: "Policía de seguridad pública",
		touristType13: "Bomberos y rescatistas",
		touristType14: "Personal médico",
		touristType15: "Profesores",
		touristType16: "Personal local registrado",
		touristType17: "Guía turístico",
		touristType18: "Personal de acompañamiento de la División",
		touristType19: "Reporteros de medios",
		touristType20: "La política estipula personal preferencial",
		touristType21: "Estudiantes universitarios",
		touristType22: "Estudiantes de secundaria",
		touristType23: "Estudiantes de primaria",
		touristType24: "Un voto y más personas",
		personTicketBindingMode1: "Un certificado, una persona",
		personTicketBindingMode2: "Un certificado y varias personas",
		enablePasswordMode1: "No abrir",
		enablePasswordMode2: "Abrir",
		/* 补译*/
		areaName: "Cuando el tipo es tarjeta gratuita de identificación, la palabra clave del área no puede estar vacía.",
		minAge: "Cuando el tipo es tarjeta gratuita de identificación, la edad no puede estar vacía.",
		minAge1: "Cuando el tipo es tarjeta gratuita de identificación, la palabra clave del área no puede ser mayor de 180 caracteres.",
		minAge2: "Cuando el tipo es tarjeta gratuita de identificación, la edad no puede ser mayor de 3 caracteres",
		minAge3: "Cuando el tipo es una tarjeta gratuita de identificación, debe seleccionar el tipo",
		minAge4: "El período de tiempo limitado no puede ser superior a 1 año",
		card: "Editar la información de la membresía de acuerdo con la plantilla, al seleccionar el tipo de billete correspondiente, el Estado solo puede elegir si no se ha verificado o no se ha activado, seleccionar no se ha verificado el billete, la categoría de tarjeta se venderá directamente, la tarjeta comenzará a usarse directamente, no se activará se venderá la tarjeta, pero debe activarse por segunda vez en la ventana, la hora de inicio efectiva de la tarjeta es la hora de activación.",
		upload: "Seleccionar archivo",
		upload1: "Cargar información de membresía",
		excel: "Exportar información de membresía",
		jihuo: "Activar",

		upload2: "La carga falló, por favor verifique cuidadosamente la información del personal",
		jihuo1: "Esta operación activará la tarjeta y si continuar la operación ",
		jihuo2: "Esta operación activará la tarjeta, que estará disponible después de activarla",
		jihuo3: "Activación exitosa",
		jihuo4: "Falló la activación",
		cardtext: "Información de la tarjeta de membresía",
		ticketRefund: "Detalles del reembolso",
		Supplementary: "Detalles de reposición",
		goods: " Configuración de la mercancía",
		shops: "Gestión de tiendas",
		gatalogue: "Catálogo de productos básicos",
		commodity: "Detalles de los productos básicos",
		goodsloading: "Entrada de productos básicos",
		Inventory: "Detalles del inventario de productos básicos",
		Commoditysales: "Detalles de los pedidos de productos básicos",
		Salesdetails: "Detalles de las ventas de productos básicos",
		Entry: "Entrada de entradas",
		Ticket_Inventory: "Inventario de entradas",
		Warehouse: "Gestión de inventarios",
		Shareholder: "Gestión de accionistas",
		Share: "Derechos e intereses de los accionistas",
		Statement: "Detalles de los ingresos",
		scan: "Escaneo de entradas",
		sellgoods: "Venta de bienes",
		useType: "Tipo de uso",
		Mobile: "Teléfono",
		Mobile1: "Introduzca el teléfono",
		actualOrderAmount: "Monto real del pedido",
		inValidOrderCount: "Número de pedidos no válidos",
		refundOrderAmount: "Importe del pedido de reembolso",
		refundOrderCount: "Número de pedidos de reembolso",
		totalOrderCount: " Número de pedidos totales",
		totalValidOrderAmount: "Importe del pedido válido",
		totalValidOrderCount: "Número de pedidos válidos",
		touristIDCardNum: "Tarjeta de identificación",
		ota: "Fuentes de OTA",
		lyd: "Lugar de origen",
		unUsedTicketAmount: "Cantidad de billetes no cancelados",
		unUsedTicketCount: "Número de entradas no canceladas",
		usedTicketAmount: "Importe de la cancelación de billetes",
		usedTicketCount: "Número de entradas canceladas",
		refundTicketAmount: "Importe del reembolso",
		refundTicketCount: "Número de devoluciones",
		tickettime: "Tiempo de compra de billetes",
		headPhoto: "Foto",
		wu: "Ninguno",
		ticketChannel: "Fuentes de distribución",
		totalCount: " Número total de personas",
		enterCount: " Número de entradas",
		outCount: "Número de personas que salen",
		realTimeCount: " Número de personas presentes",
		zoneName: "Atracciones",
		deviceName: "Equipo",
		enterCount1: "Detalles de entrada y salida",
		query1: "Estadísticas detalladas de entrada y salida",
		query2: "Detalles de entrada y salida de equipos",
		headPhoto: "Foto",
		ticket_card: "Introduzca el número de la tarjeta de membresía",
		IDcardticketMedium: "Introduzca el número de identificación",
		transPrice: "Precio unitario de la transacción",
		ticketStatus: "Tiempo de pedido",
		rticket: "Reembolso de entradas",
		rgoods: "Devolución de mercancías",
		ticket_qz: "Reembolso obligatorio",
		return_text: "Reembolso obligatorio (reembolso obligatorio aquí para entradas canceladas o usadas)",
		isRefundCheck: "Si revisar",
		refundCheckStatus: "Estado de la auditoría",
		usedTime: "Tiempo de uso",
		cz: "Operación",
		RefundCheck: "Presentación para revisión",
		printtext1: "【impresión de entradas】",
		printtext2: "【Impresión de pedidos】El número de consulta ingresado es el número de pedido al principio de dd, y solo hay un boleto bajo este pedido, por lo que el boleto bajo el pedido se puede imprimir en un código QR al imprimir el pedido, y el permiso en el Código QR puede pasar el número de permisos en el boleto correspondiente.",
		printtext3: "Impresión de pedidos",
		hx1: "Cancelación de atracciones",
		hx2: "Cancelación por lotes",
		hx3: "Cancelación global",
		hx4: "【Cancelación de atracciones】Al consultar la información del turista, el pedido es un número de 18 dígitos al principio de DD y el número de billete es un número de 18 dígitos al principio de una sola letra. si el Estado del billete es no verificado, consulte la información cancelable y haga clic en cancelar para reducir el número de pases bajo la atracción correspondiente una vez",
		hx5: "【Cancelación global】Al consultar la información del turista, el pedido es un número de 18 dígitos al principio de DD y el número de billete es un número de 18 dígitos al principio de una sola letra. si el Estado del billete es no verificado, después de hacer clic en cancelar, el Estado del billete se cambia directamente al billete verificado (precaución)",
		hx6: "【Cancelación por lotes】Al consultar el número de 18 dígitos que comienza con el pedido del turista dd, se puede reducir el número de entradas bajo la atracción correspondiente en lotes de acuerdo con el número de entradas transitables consultadas.",
		totalTicketCount: "Número de entradas",
		validTicketCount: "Número de votos transitables",
		totalValidTimes: "Número de pases",
		hx7: "Número máximo de cancelables",
		hx8: "Número de cancelaciones",
		hx9: "Cancelación de entradas",
		checkPeopleCount: "Introduzca la cantidad que debe cancelarse",
		hxnum: "El número de cancelaciones no puede ser mayor que el número máximo de cancelables.",
		msgCode: "Cancelación exitosa",
		ticketID: "Introduzca el número de pedido a consultar",
		ticketIDlength: "La longitud de entrada no puede ser superior a 24 caracteres",
		Error: "Esta operación solo emitirá un billete, que se registrará en los detalles de reposición, si continúa?",
		printwarning: "La impresión del pedido falló y el pedido solo puede contener un tipo de billete",
		printwarning1: "Error de datos, falló la impresión del pedido",

		printwarning2: "¿Esta operación imprime el billete, que se registrará en los detalles de reposición, ¿ continúa?",
		settledAmount: " Importe de la liquidación",
		unSettledAmount: "No liquidado",
		Samount_dq: "Total actual",
		Samount_dq_: "Reembolso total actual",
		Samount_last: "Ingresos actuales",
		settledAmount_last: "Liquidación actual",
		unSettledAmount_last: "No liquidado",
		addjjb: "Operación de entrega",
		addgoods: "Detalles de los productos básicos",
		goodslist: "Detalles de las ventas de productos básicos",
		changeShiftsName: "Entrega",
		amount: "Total pagado",
		settledAmount: "Importe de la liquidación",
		startTime: "Hora de inicio del turno de entrega",
		endTime: "Hora de finalización del turno de entrega",
		operator: " Autor",
		operator1: " ¿Esta operación presenta la cantidad recibida actual para su liquidación y genera un registro de entrega, ¿ continúa la operación?",
		operator2: " Consejos",
		operator3: " Presentación exitosa",
		operator4: " Presentación fallida",
		query_pl: " Consulta de pedidos",
		rquery1: " Detalles de la auditoría de reembolso",
		rquery2: " Detalles del reembolso",
		orderPayment: "Método de pago",
		createTime: " Tiempo de presentación",
		orderAmount: " Monto del pedido",
		account: " Presentado al Auditor",
		refundCheckStatus: "Estado de la auditoría",
		orderTime: "Tiempo de reembolso",
		SRoot1: "En revisión",
		SRoot2: "Revisado",
		SRoot3: "Rechazada",
		SRoot4: "La auditoría falló",
		textx1: "¿Esta operación revisará que la cantidad exitosa será devuelta y generará un pedido de reembolso, ¿ continuar?",
		textx2: "Auditoría exitosa",
		textx3: "Esta operación rechazará la solicitud de reembolso del billete y si continúa",
		text4: "Rechazo exitoso",
		text5: "Falló el rechazo",
		ticket1: "Informe de entradas",
		ticketjjb: "Turno de entrega",
		ticket_zh: "Consulta integral",
		tj: "Condiciones",
		queryly: "Exportar informe de origen",
		ticketTypeName: "Tipo de billete",
		ticketPrice: "Precio unitario del billete",

		ticketCount: " Número de ventas",
		amount1: " Total",
		offline_ticketCount: " Número de ventas fuera de línea",
		offline_amount: " Cantidad de ventas fuera de línea",
		OTA_ticketCount: " Número de ventas en línea",
		OTA_amount: " Cantidad de ventas en línea",

		amount2: "Importe total",
		totalTicketCount: "Número total de entradas",
		window_cashTicketCount: " Votos en efectivo de la ventana",
		window_cash: "  Caja registradora de efectivo de ventanilla",
		window_wxTicketCount: "Votos de Wechat en la ventana",
		window_wxAmount: "Ventana Wechat caja registradora",
		window_zfbTicketCount: "Votos de Alipay en la ventana",
		window_zfbAmount: "Caja registradora de Alipay de ventanilla",
		terminal_wxTicketCount: "Número de votos de Wechat en la terminal",
		terminal_wxAmount: "Caja registradora de Wechat de la terminal",
		terminal_zfbTicketCount: "Número de votos de Alipay en la terminal",
		terminal_zfbAmount: "Terminal Alipay caja registradora",
		OTA_ticketCount: "OTA Número de votos distribuidos",
		OTA_amount: "OTA Importe de la distribución",
		shareHolderName: "Empresas rentables",
		shareHolder: "Ingresos",
		refundCount: "Número de devoluciones",
		refundTodayTicketCount: "Número de votos emitidos el día de la devolución",
		refundPreviousTicketCount: "Número de votos devueltos para hacer pedidos en el pasado",
		businessTicketCount: "Contar los votos de las transacciones",
		textly1: "Detalles de los canales de distribución en línea",
		textly2: "Estadísticas de tipos de billetes",
		textly3: "Estadísticas de fuentes de billetes",
		ptkly: "Detalles de la fuente",
		textentry: "¡Edite la información del billete de acuerdo con la plantilla. al seleccionar el tipo de billete correspondiente, el Estado solo puede seleccionar si el billete no ha sido verificado o si se ha almacenado. elija si el billete no ha sido verificado. ¡ la categoría del billete se venderá directamente y el billete comenzará a usarse directamente! Los billetes almacenados se colocarán en el almacén de billetes y se venderán en la parte delantera.",
		textexcel: "Cargar archivos",
		uptabledata: "Cargar información del billete",
		textentry1: "Después de la operación de almacenamiento exitosa, la información del billete se puede ver en el inventario de boletos. Cuando la operación de importación fue exitosa en un Estado no verificado. Los billetes están directamente vinculados a la cuenta del conductor para su venta. Y se generará un pedido. Vea en los detalles del pedido, la información del billete también estará en el informe de inventario de entradas.",
		textentry2: "Tiempo de importación",
		textentry3: "Número de entrada",
		textentry4: "Eliminar la información del billete",
		ticketzt: "Estado de importación",
		ticketzt1: "Se ha almacenado",
		ticketzt2: "La carga falló, por favor verifique cuidadosamente la información del billete",
		qx: "Cancelación",
		ticketzt3: "¡¡ la longitud del billete no puede ser mayor de 18 dígitos! Falló la verificación de carga",
		ticketzt4: "¡¡ la longitud del billete no puede estar libre! Falló la verificación de carga",
		ticketzt5: "El número de billete contiene caracteres chinos o especiales, la carga falló la verificación",
		ticketzt6: "Hay números de votación duplicados",
		ticketzt7: "Por favor, suba el archivo",
		ticketzt8: "Por favor, elija el lugar escénico",
		ticketzt9: "Por favor, elija el Estado",
		ticketzt10: "Por favor, elija el conductor vinculado",
		ticketzt11: "Por favor, elija el tipo de billete vinculado",
		ticketzt12: "La carga de la información fue exitosa",
		ticketzt13: "Falló la carga del mensaje",
		ticketzt14: " El formato del anexo es incorrecto, por favor elimine y vuelva a subirlo",
		ticketzt15: " Por favor, suba el Anexo",
		ticketzt16: "Por favor, seleccione los boletos que deben eliminarse.",
		ticketzt17: "La operación eliminará la factura seleccionada",
		ticketztx: "Billetes no inspeccionados",
	},
	btn: {
		add: "nuevo",
		edit: "editar",
		delete: "Eliminar",
		query: "Preguntar",
		download: "descargar",
		submit: "Entregar",
		cancel: "Cancelar",
		reset: "Reiniciar",
		personnelAuthorization: "Autorización de personal",
		text2: "Soporte técnico por",
		text3: "Por favor, inicie sesión con IE9 o superior, EDGE, google, Opera",
		text4: " La cuenta no puede estar vacía",
		text5: " La contraseña no puede estar vacía",
		text6: "Inicio de sesión exitoso, carga en curso.....",
		text7: "Falló el inicio de sesión y el servicio no está conectado",
		touristMobile: "La longitud del teléfono no puede ser superior a 11 dígitos",
		touristIDCardNum: "La longitud de la tarjeta de identificación no puede ser superior a 18 dígitos.",
		xlabel1: "not have",
		xlabel2: "WeChat official account",
		xlabel3: "Self service terminal",
		xlabel4: "OTA",
		xlabel5: "WeChat mini program",
	},
	egsRouteName: {
		home: 'Casa',
		personnelList: 'Lista de miembros'
	},
	rightMenu: {
		close: 'cierre',
		closeOther: 'cerrar otro',
		closeAll: 'cierra todo'
	},
	role: {
		superAdmin: 'superadministrador',
		admin: 'administrador',
		ordinary: 'usuario general'
	},
	userDropdownMenu: {
		basicInfor: 'información básica',
		changePassword: 'cambiar la contraseña',
		logout: 'Abandonar'
	},
	message: {
		selectNoData: 'no se encontraron datos',
	},

	...esLocale   //  合并element-ui内置翻译
}

export default es



// WEBPACK FOOTER //
// ./src/i18n/lang/es.js